// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce #easycommerce_store_render .easycommerce-coupon-input {
    width: 100%;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    color: var(--color-ec-body);
    border: 1px solid var(--color-ec-border);
    border-radius: 8px;
    padding: 12px;
    transition: 0.3s all ease-in-out;
}
.easycommerce #easycommerce_store_render .easycommerce-coupon-input:hover {
    border: 1px solid var(--color-ec-secondary);
}
.easycommerce
    #easycommerce_store_render
    .easycommerce-coupon-input::-moz-placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce
    #easycommerce_store_render
    .easycommerce-coupon-input::placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce #easycommerce_store_render .easycommerce-coupon-input:focus {
    border: 1px solid var(--color-ec-primary);
    box-shadow: 0px 2px 4.5px 0px var(--color-ec-shadow);
    outline: none;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/pages/Coupons/CouponDetails/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,gCAAgC;AACpC;AACA;IACI,2CAA2C;AAC/C;AACA;;;IAGI,kCAAkC;AACtC;AAJA;;;IAGI,kCAAkC;AACtC;AACA;IACI,yCAAyC;IACzC,oDAAoD;IACpD,aAAa;AACjB","sourcesContent":[".easycommerce #easycommerce_store_render .easycommerce-coupon-input {\n    width: 100%;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 26px;\n    color: var(--color-ec-body);\n    border: 1px solid var(--color-ec-border);\n    border-radius: 8px;\n    padding: 12px;\n    transition: 0.3s all ease-in-out;\n}\n.easycommerce #easycommerce_store_render .easycommerce-coupon-input:hover {\n    border: 1px solid var(--color-ec-secondary);\n}\n.easycommerce\n    #easycommerce_store_render\n    .easycommerce-coupon-input::placeholder {\n    color: var(--color-ec-placeholder);\n}\n.easycommerce #easycommerce_store_render .easycommerce-coupon-input:focus {\n    border: 1px solid var(--color-ec-primary);\n    box-shadow: 0px 2px 4.5px 0px var(--color-ec-shadow);\n    outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
